import React, { useEffect, useState, useContext } from 'react';
import Modal from '../../../UI/Modal/Modal';
import Form from '../../../../assets/Style/Form.module.css';
import cl from './FinalRecipient.module.css'
import Id from "../../../../assets/Icon/Id";  
import Mobile from "../../../../assets/Icon/Mobile";  
import User from "../../../../assets/Icon/User";  
import { AppContext } from '../../../../providers/appProvider';

const FinalRecipient = ({ isOpen, open, onClose, onSave, car }) => {

  const { app } = useContext(AppContext);

  const [finalDetails, setFinalDetails] = useState({
    final_recipient_firstname: '',
    final_recipient_lastname: '',
    final_recipient_personal: '',
    final_recipient_mobile: '',

  });

  const handleChange = (event) => {

    const { name, value } = event.target;

      setFinalDetails({
        ...finalDetails,
        [name]: value
      });
  
  };

  const handleSave = () => {
    onSave(finalDetails);
    onClose();
  };


  useEffect(() => {
 
    setFinalDetails({
        final_recipient_firstname: car.final_recipient_firstname, 
        final_recipient_lastname: car.final_recipient_lastname, 
        final_recipient_personal: car.final_recipient_personal, 
        final_recipient_mobile: car.final_recipient_mobile, 
    });

  }, [car]);

 
  return (
    <div>

      <div>
        {
            (typeof finalDetails.final_recipient_firstname === "undefined" || typeof finalDetails.final_recipient_lastname === "undefined" ?
              <div style={{ cursor: 'pointer' }} onClick={() => { open(true) }}> --- </div>
              :
              <div style={{ cursor: 'pointer' }} onClick={() => { open(true) }}>
                {`${car.final_recipient_firstname} ${car.final_recipient_lastname}`}
              </div>
            )
        }

      </div>

      <Modal isOpen={isOpen} onClose={onClose}>

        <div className={cl.modalHead} >
            <h3> საბოლოო მიმღები </h3>
        </div>

        <div className={Form.modalContent}>
 
          <div className={cl.inp2col}>

            <div className={cl.groupInput}>
                <div className={cl.groupInputIcon}>
                    <input 
                        type="textS" 
                        className={  cl.input  } 
                        placeholder="სახელი" 
                        name="final_recipient_firstname" 
                        value={finalDetails.final_recipient_firstname} 
                        onChange={handleChange} 
                        autoComplete="off" 
                    />
                    <div className={cl.crmIcon}><User/></div>
                </div>
            </div>

            <div className={cl.groupInput}>
                <div className={cl.groupInputIcon}>
                    <input 
                          type="textS" 
                          className={ cl.input }
                          placeholder="გვარი" 
                          name="final_recipient_lastname" 
                          value={finalDetails.final_recipient_lastname} 
                          onChange={handleChange} 
                          autoComplete="off"
                    />
                    <div className={cl.crmIcon}><User /></div>
                </div>
            </div>

          </div>


        <div className={cl.groupInput}>
          <div className={cl.groupInputIcon}>
              <input 
                    type="textS" 
                    className={ cl.input } 
                    placeholder="პირადი ნომერი" 
                    name="final_recipient_personal" 
                    value={finalDetails.final_recipient_personal} 
                    onChange={handleChange} 
                    autoComplete="off"
               />
              <div className={cl.crmIcon}><Id /></div>
          </div> 
        </div>

        <div className={cl.groupInput}>
          <div className={cl.groupInputIcon}>
              <input 
                    type="textS" 
                    className={ cl.input } 
                    placeholder="საკონტაქტო" 
                    name="final_recipient_mobile" 
                    value={finalDetails.final_recipient_mobile} 
                    onChange={handleChange} 
                    autoComplete="off"
              />
              <div className={cl.crmIcon}><Mobile /></div>
          </div> 
        </div>

        {app.hasPermission("FINAL_RECIPIENT_UPDATE") &&
          <button onClick={handleSave} className={Form.btnPrimary}>
            შენახვა
          </button>
        }



        </div>
      </Modal>

    </div>
  );
};

export default FinalRecipient;
